import React, { Component } from 'react'
import { Button, Form, Table, Input, message, Row, Col, DatePicker } from 'antd'

import { getOrderStatusName } from '_src/utils/tool'

import { getHealthForeign } from '_src/api/api'
import moment from 'moment'


import exportExcel from '_src/utils/exportExcel'

const { Search } = Input
class HealthOderForeign extends Component {
  constructor (props) {
    super(props)
    this.firstLoad = true // 是否第一次加载
    this.loading = true
    this.date = moment().format('YYYY-MM-DD')
    this.param = {
      passengerName: ''
    }
  
    this.state = {
      dataList: [],
      excelList: [],
    
    }
  }

  componentDidMount () {
    this.loadData()
  }
  loadData () {
    getHealthForeign({date: this.date})
      .then(res=>{
        this.loading = false
        const { data } = res
  
        const dataList = data.map((item, index)=>{
          let { expireAt } = item
          expireAt = moment(expireAt).format('YYYY-MM-DD HH:mm')
          const { startStationName, busDestination, lineDestination } = item
          const line = `${startStationName}-${busDestination}-${lineDestination}`
          return {index: (index+1), ...item, line, key: index, expireAt }
        })
        this.saveDataList = dataList
        this.setState(()=>({
          dataList: dataList,
          visible: false
        }))
        this.setState(()=>({
          excelList: [...dataList]
        }))
        if (this.firstLoad) {
          this.firstLoad = false
        }
      })
  }
  columns = () => {
    return [
      {
        title: '排序',
        align: 'center',
        dataIndex: 'index',
        key: 'index',
      },
      {
        title: '订单号',
        align: 'center',
        dataIndex: 'orderSn',
        key: 'orderSn',
        
      },
      {
        title: '起始站',
        align: 'center',
        dataIndex: 'line',
        key: 'line',
        
      },
      {
        title: '旅客信息',
        align: 'center',
        dataIndex: 'info',
        key: 'info',
      },
      {
        title: '成人票人数',
        align: 'center',
        dataIndex: 'adultCount',
        key: 'adultCount',
      },
      {
        title: '儿童票人数',
        align: 'center',
        dataIndex: 'childCount',
        key: 'childCount',
      },
      // {
      //   title: <span>专题数量</span>,
      //   align: 'center',
      //   dataIndex: 'link',
      //   render: item => <a href={item} target='_blank'>{item}</a>
      // },
      {
        title: '乘车日期',
        align: 'center',
        dataIndex: 'expireAt',
        key: 'expireAt',
       
      },
      {
        title: '联系电话',
        align: 'center',
        dataIndex: 'mobile',
        key: 'mobile',
        
      },
      {
        title: '订单状态',
        align: 'center',
        dataIndex: 'status',
        key: 'status',
        render: type => <span>{getOrderStatusName(type)}</span>
      },
     
    
    ]
  }

 
  handleSearch = (key, v) => {
    this.param[key] = v
    const filterList = !!v?this.saveDataList.filter(item => {
      return item.info.indexOf(v) > -1
    }):this.saveDataList
    this.setState({
      dataList: filterList
    })
  }

  handleChangeDate = (_, dateString) => {
    this.date = dateString
    this.loadData()
  }
  handleExcel = () => {
    const { excelList } = this.state
    let now = moment().format('YYYY-MM-DD')
    if (!!excelList.length) {
      const cols = [{ wpx: 80 }, { wpx: 100 }, { wpx: 200 }, { wpx: 250 }, { wpx: 150 }, { wpx: 100 }, { wpx: 100 },{ wpx: 100 }]
      exportExcel(this.columns(), excelList, `第三方健康专线${now}总订单`, cols) 
    }
    else {
      message.error('没有需要导出的数据', 1.5)
    }
  }

  render () {
    const { dataList } = this.state
    return (
      <div className = "Special">
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
            <Row gutter = {24}>
             
              <Col span = {8}>
                <Form.Item label = "日期选择" >
                  <DatePicker onChange = {this.handleChangeDate} defaultValue = {moment()} /> 
                </Form.Item>
              </Col>
              <Col span = {8}>
                <Form.Item label = "旅客姓名" >
                  <Search placeholder="请输入旅客姓名" onSearch={(v)=>{ this.handleSearch('passengerName', v) }} enterButton />
                </Form.Item>
              </Col>
              <Col span = {8}>
                <Form.Item style = {{float: 'right'}}>
                  <Button type = "primary" icon="download" onClick = { this.handleExcel }>导出</Button>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
        <Table
          loading = {this.loading} 
          bordered
          columns = {this.columns()} 
          dataSource = {dataList}
        />
      </div>
    )
  }
}

export default HealthOderForeign